if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType || "page";

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const variantId = formData.get("id");
        const requestedQty = parseInt(formData.get("quantity")) || 1;

        if (this.cart && typeof this.cart.getSectionsToRender === "function") {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
        } else {
          formData.append("sections", []);
        }

        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        // Fetch current cart to know previous quantity of this variant
        fetch(`${routes.cart_url}.js`)
          .then((r) => r.json())
          .then((cartBefore) => {
            const prevItem = cartBefore.items.find(
              (item) => String(item.variant_id) === String(variantId),
            );
            const prevQty = prevItem ? prevItem.quantity : 0;

            return fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: variantId,
                    errors: response.errors || response.description,
                    message: response.message,
                  });

                  // Friendly inventory error message
                  const inventoryEl = this.closest("section")?.querySelector(
                    "[data-inventory-quantity]",
                  );
                  const availableQty = inventoryEl
                    ? parseInt(inventoryEl.dataset.inventoryQuantity)
                    : null;
                  let friendlyMessage = response.description;
                  const remaining =
                    availableQty !== null ? availableQty - prevQty : null;

                  if (remaining !== null && remaining > 0 && response.description) {
                    friendlyMessage =
                      remaining === 1
                        ? "Somente 1 item foi adicionado ao seu carrinho devido à disponibilidade."
                        : `Somente ${remaining} itens foram adicionados ao seu carrinho devido à disponibilidade.`;

                    const counterInput =
                      this.form.querySelector(".js-counter-quantity");
                    if (counterInput) {
                      counterInput.value = remaining;
                      counterInput.dispatchEvent(
                        new Event("change", { bubbles: true }),
                      );
                    }
                  }

                  this.handleErrorMessage(friendlyMessage);
                  this.error = true;

                  const soldOutMessage =
                    this.submitButton.querySelector(".sold-out-message");

                  this.dispatchEvent(
                    new CustomEvent("cart-drawer:refresh", {
                      detail: { response: response },
                      bubbles: true,
                      composed: true,
                    }),
                  );

                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute("aria-disabled", true);
                  this.submitButton.querySelector("span").classList.add("hidden");
                  soldOutMessage.classList.remove("hidden");
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                // Check if Shopify silently capped the quantity
                let totalQtyAfter = prevQty + requestedQty;
                if (response.items && Array.isArray(response.items)) {
                  const cartItem = response.items.find(
                    (item) => String(item.variant_id) === String(variantId),
                  );
                  if (cartItem) totalQtyAfter = cartItem.quantity;
                }

                const actuallyAdded = totalQtyAfter - prevQty;

                if (actuallyAdded > 0 && actuallyAdded < requestedQty) {
                  this._inventoryWarningMsg =
                    actuallyAdded === 1
                      ? "Somente 1 item foi adicionado ao seu carrinho devido à disponibilidade."
                      : `Somente ${actuallyAdded} itens foram adicionados ao seu carrinho devido à disponibilidade.`;

                  // Adjust counter to remaining available
                  const counterInput =
                    this.form.querySelector(".js-counter-quantity");
                  if (counterInput) {
                    counterInput.value = 1;
                    counterInput.max = actuallyAdded;
                    counterInput.dispatchEvent(
                      new Event("change", { bubbles: true }),
                    );
                  }
                }

                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "product-form",
                    productVariantId: variantId,
                    cartData: response,
                  });
                this.error = false;
                const quickAddModal = this.closest("quick-add-modal");
                if (quickAddModal) {
                  document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.redirectAfterSubmit(response);
                      });
                    },
                    { once: true },
                  );
                  if (this.cartType === "drawer") quickAddModal.hide(true);
                } else {
                  const isClosedCart = !document.body.classList.contains(
                    "page-overlay-cart-on",
                  );
                  this.redirectAfterSubmit(response, isClosedCart);
                }
              });
          })
          .catch((e) => {
            console.error(e);
            if (e instanceof TypeError && e.message.includes("'cart-drawer'")) {
              location.reload();
            }
          })
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            this.submitButton.removeAttribute("aria-disabled");
            if (this.error) {
              this.disableLoadingInButton();
              return;
            }
            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container.querySelector(".wt-product");
            this.loader = this.quick_add_container.querySelector(
              ".wt__quick-buy-loader",
            );

            if (!this.quick_add_container.classList.contains("hidden")) {
              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader.classList.remove("hidden");
            }

            // delay button loading
            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          this.showInventoryWarningInDrawer();
          return;
        }
        window.location = window.routes.cart_url;
      }

      showInventoryWarningInDrawer() {
        const warning = document.getElementById("CartDrawer-InventoryWarning");
        if (!warning) return;

        clearTimeout(this._inventoryWarningTimer);
        warning.classList.remove("wt-cart__inventory-warning--fade-out");

        if (this._inventoryWarningMsg) {
          warning.querySelector("p").textContent = this._inventoryWarningMsg;
          warning.removeAttribute("hidden");
          this._inventoryWarningMsg = null;

          this._inventoryWarningTimer = setTimeout(() => {
            warning.classList.add("wt-cart__inventory-warning--fade-out");
            warning.addEventListener(
              "transitionend",
              () => warning.setAttribute("hidden", ""),
              { once: true },
            );
          }, 5000);
        } else {
          warning.setAttribute("hidden", "");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
